import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { SelectOption } from '@americanexpress/dls-react';
import { FxSelectField } from './FxSelectField';
import { FxReactFinalFormWrapper } from '../FxReactFinalFormWrapper';

const tzId = {
  id: 'timezone',
  name: 'timezone',
  component: FxSelectField,
  label: 'Default time zone',
  className: 'col-md-12 pad-0-lr',
  showEmptyOption: false,
};

export const FxTimeZoneField = ({
  defaultTimeZone,
  timeZones,
  handleTimeZoneChange,
}) => {
  const getTimeZoneOptions = () => {
    const markup = [];

    if (timeZones?.length > 0) {
      timeZones.forEach((data) => {
        markup.push(
          <SelectOption id={data.timeZoneId} value={data.timeZoneLocation}>
            {data.timeZoneUTCOffset}
          </SelectOption>
        );
      });
    } else {
      markup.push(
        <SelectOption
          id={defaultTimeZone.timeZoneId}
          value={defaultTimeZone.timeZoneLocation}
        >
          {defaultTimeZone.timeZoneUTCOffset}
        </SelectOption>
      );
    }
    return markup;
  };

  const handleOnChange = (event) => {
    handleTimeZoneChange(event);
  };

  return (
    <FxReactFinalFormWrapper
      initialValues={{ timezone: defaultTimeZone.timeZoneLocation }}
    >
      <Field
        {...tzId}
        value={defaultTimeZone.timeZoneLocation}
        selectOptions={getTimeZoneOptions()}
        handleOnChange={handleOnChange}
      />
    </FxReactFinalFormWrapper>
  );
};

export const timeZoneProp = {
  timeZoneId: PropTypes.string.isRequired,
  timeZoneLocation: PropTypes.string.isRequired,
  timeZoneCode: PropTypes.string.isRequired,
  timeZoneUTCOffset: PropTypes.string.isRequired,
};

FxTimeZoneField.propTypes = {
  defaultTimeZone: PropTypes.shape(timeZoneProp).isRequired,
  timeZones: PropTypes.arrayOf(timeZoneProp),
  handleTimeZoneChange: PropTypes.func,
};

FxTimeZoneField.defaultProps = {
  handleTimeZoneChange: () => {},
};
